<template>
  <v-container>
    <v-row>
      <v-col class="text-center">
        <h1 class="d-inline customer--title text-center">
          {{ $t('title') }}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="mx-auto"
        cols="11"
      >
        <v-radio-group
          id="tipoPago"
          v-model="tipoPago"
          name="tipoPago"
          class="justify-center"
          row
          @change="limpiarFiltros"
        >
          <v-radio
            class="mb-3"
            :label="$t('form.label.numero_referencia')"
            :value="true"
          />
          <v-radio
            class="mb-3"
            :label="$t('form.label.numero_identificacion')"
            :value="false"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <ValidationObserver
      v-if="tipoPago"
      ref="obs"
      v-slot="{ passes }"
    >
      <v-form
        @submit.prevent="passes(filtrarPorReferencia)"
      >
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="mx-auto justify-center"
            sm="8"
            md="6"
          >
            <v-row>
              <v-col
                class="mx-auto"
                cols="11"
                sm="9"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('form.label.referencia')"
                  :rules="validacionesFormulario.referencia"
                  vid="referencia"
                >
                  <v-text-field
                    id="referencia"
                    v-model.trim="modelo.referencia"
                    :error-messages="errors"
                    :label="$t('form.label.referencia')"
                    type="text"
                    background-color="white"
                    class="required"
                    name="referencia"
                    dense
                    outlined
                    required
                  />
                </ValidationProvider>
              </v-col>
              <v-col
                class="d-flex justify-center justify-sm-start"
                cols="12"
                sm="3"
              >
                <v-btn
                  color="secondary"
                  type="submit"
                  large
                  dark
                >
                  {{ $t('form.button.aceptar') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
    <ValidationObserver
      v-else
      ref="obsForm"
      v-slot="{ passes }"
    >
      <v-form
        @submit.prevent="passes(filtrarPorIdentificacion)"
      >
        <v-row>
          <v-col
            class="mb-0 py-0 mx-auto"
            cols="11"
            sm="10"
            md="5"
          >
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.tipo_documento')"
              :rules="validacionesFormulario.tipoDocumentoId"
              vid="tipoDocumentoId"
            >
              <v-autocomplete
                id="tipoDocumentoId"
                v-model="modelo.tipoDocumentoId"
                :error-messages="errors"
                :label="$t('form.label.tipo_documento')"
                :items="tipoDocumentoIds"
                class="required"
                item-text="descripcion"
                item-value="id"
                background-color="white"
                name="tipoDocumentoId"
                filled
                return-object
                dense
                outlined
                v-on="$listeners"
                @change="limpiarFechaNacimiento()"
              />
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              :name="$t('form.label.numero_documento')"
              :rules="validacionesFormulario.numeroDocumento"
              vid="numeroDocumento"
            >
              <v-text-field
                id="numeroDocumento"
                v-model.trim="modelo.numeroDocumento"
                :error-messages="errors"
                :label="$t('form.label.numero_documento')"
                type="text"
                background-color="white"
                class="required"
                name="numeroDocumento"
                dense
                outlined
                required
              />
            </ValidationProvider>
          </v-col>
          <v-col
            class="mb-0 py-0 mx-auto"
            cols="11"
            sm="10"
            md="5"
            offset-md="2"
          >
            <v-menu
              ref="datePickerFechaNacimiento"
              v-model="datePickerFechaNacimiento"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('form.label.fecha_nacimiento')"
                  vid="fechaNacimiento"
                >
                  <v-text-field
                    id="fechaNacimiento"
                    v-model="modelo.fechaNacimiento"
                    :error-messages="errors"
                    :label="$t('form.label.fecha_nacimiento')"
                    :disabled="modelo.tipoDocumentoId && modelo.tipoDocumentoId.codigo === 'NIT'"
                    hint="Formato YYYY-MM-DD"
                    persistent-hint
                    :class="modelo.tipoDocumentoId && modelo.tipoDocumentoId.codigo === 'NIT' ? '' : ''"
                    background-color="white"
                    name="fechaNacimiento"
                    filled
                    return-object
                    readonly
                    dense
                    outlined
                    v-on="on"
                  />
                </ValidationProvider>
              </template>
              <v-date-picker
                v-model="modelo.fechaNacimiento"
                :max="maximaFecha"
                no-title
                @input="datePickerFechaNacimiento = false"
              />
            </v-menu>
            <v-row>
              <v-col class="d-flex justify-center justify-sm-start">
                <v-btn
                  large
                  color="secondary"
                  type="submit"
                  dark
                >
                  {{ $t('form.button.aceptar') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="11"
        sm="8"
        class="mx-auto text-justify text-md-center"
      >
        <label
          class="v-label theme--light"
          for=""
        >
          {{ $t('texto_informativo') }}
        </label>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <formulario-referencia
          v-if="tipoPago"
          ref="formularioReferencia"
          :tipo-documento-ids="tipoDocumentoIds"
          :obra-ids="obraIds"
          :tipos-de-monedas="tiposDeMonedas"
        />
        <formulario-identificacion
          v-else
          ref="formularioIdentificacion"
          :obra-ids="obraIds"
          :tipos-de-monedas="tiposDeMonedas"
          :referencias="referencias"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import handleErrorMixin from '../../../../../mixins/handleErrorMixin'
import validateQueryParamsMixin from '@/mixins/validateQueryParamsMixin'
import generalParametersMixin from '@/mixins/generalParametersMixin'
import validacionesFormulario from './data/pagosEnLineaValidations'
import FormularioReferencia from './components/formularioReferencia/FormularioReferencia'
import FormularioIdentificacion from './components/formularioIdentificacion/FormularioIdentificacion'
import { TRAER_TIPOS_DOCUMENTOS, TRAER_OBRAS, TRAER_TIPO_MONEDA, FILTRAR_REFERENCIAS, FILTRAR_IDENTIFICACION } from './data/pagosEnLineaConstants'
import { SHOW_ALERT, CHANGE_LANGUAGE } from '../../../../../store/mutations-types'
import { NOT_FOUND } from '../../../../../shared/constants/httpStatus'
import { mapState } from 'vuex'

export default {
  name: 'PagosEnLinea',
  components: {
    FormularioReferencia,
    FormularioIdentificacion
  },
  mixins: [ handleErrorMixin, validateQueryParamsMixin, generalParametersMixin ],
  data () {
    return {
      modelo: {
        tipoDocumentoId: null,
        numeroDocumento: null,
        fechaNacimiento: null,
        referencia: null
      },
      validaQueryParam: {
        data: 'referencia',
        query: 'referencia',
        valida: false
      },
      referencias: null,
      precargarDatosIdentificacion: null,
      tipoPago: true,
      date: null,
      datePickerFechaNacimiento: false,
      tipoDocumentoIds: [],
      objObra: null,
      obraIds: [],
      tiposDeMonedas: [],
      validacionesFormulario: validacionesFormulario
    }
  },
  computed: {
    ...mapState(['configColor']),
    maximaFecha () {
      var d = new Date()
      return `${d.getFullYear()}-12-31`
    }
  },
  watch: {
    date (val) {
      this.modelo.fechaNacimiento = this.formatDate(this.date)
    }
  },
  created () {
    this.$store.commit(CHANGE_LANGUAGE, 'es')
    this.locale = this.$store.state.changeLanguage
    this.$root.$i18n.locale = this.$store.state.changeLanguage
    this.conseguirTipoDocumento()
    this.conseguirObras()
    this.conseguirTipoMoneda()
    this.validarQueryParams()
  },
  destroyed () {
    this.$_generalParametersMixin_update(this.configColor.primary, this.configColor.secondary, this.generalParametersUrlLogo)
  },
  methods: {
    filtrarPorReferencia () {
      this.axios.get(`${FILTRAR_REFERENCIAS}${this.modelo.referencia}`).then((response) => {
        this.$refs.formularioReferencia.llenarFormulario(response.data)
        this.$refs.formularioReferencia.referencia = this.modelo.referencia
        this.$refs.formularioReferencia.deshabilitarBoton = false
      }).catch(error => {
        this.$refs.formularioReferencia.referencia = null
        this.$refs.formularioReferencia.deshabilitarBoton = true
        if (error.response.status === NOT_FOUND) {
          this.$store.commit(SHOW_ALERT, {
            type: 'warning',
            timeout: 0,
            text: this.$t('referencia_404')
          })
          this.$refs.formularioReferencia.llenarFormulario(null)
        } else {
          this.$_handleErrorMixin_generateError(error)
        }
      })
    },
    filtrarPorIdentificacion () {
      this.axios.get(FILTRAR_IDENTIFICACION, {
        params: {
          tipoDocumentoId: this.modelo.tipoDocumentoId.id,
          numeroDocumento: this.modelo.numeroDocumento,
          fechaNacimiento: this.modelo.fechaNacimiento
        }
      }).then((response) => {
        this.$refs.formularioIdentificacion.objtipoDocumentoId = this.modelo.tipoDocumentoId
        if (response.data.length > 1) {
          this.referencias = response.data
          this.$refs.formularioIdentificacion.$refs.modalReferencias.mostrarModal = true
        } else if (response.data.length === 1) {
          this.$refs.formularioIdentificacion.llenarFormulario(response.data[0], this.modelo.tipoDocumentoId && this.modelo.tipoDocumentoId.codigo === 'NIT')
        }
      }).catch(error => {
        if (error.response.status === NOT_FOUND) {
          this.$store.commit(SHOW_ALERT, {
            type: 'warning',
            timeout: 0,
            text: this.$t('referencia_404')
          })
        } else {
          this.$_handleErrorMixin_generateError(error)
        }
      })
    },
    /**
   * Metodo para traer las obras.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    conseguirObras () {
      this.axios.get(TRAER_OBRAS).then((response) => {
        this.obraIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.status === NOT_FOUND) {
          this.obraIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    /**
   * Metodo para traer los Tipos de documentos.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    conseguirTipoDocumento () {
      this.axios.get(`${TRAER_TIPOS_DOCUMENTOS}ES`, { params: { donacion: false } }).then((response) => {
        this.tipoDocumentoIds = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.status === NOT_FOUND) {
          this.tipoDocumentoIds = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    limpiarFechaNacimiento () {
      if (this.modelo.tipoDocumentoId.codigo === 'NIT') {
        this.modelo.fechaNacimiento = null
        this.$refs.obsForm.reset()
      }
    },
    /**
   * Metodo para traer los tipos de moneda.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    conseguirTipoMoneda () {
      this.axios.get(TRAER_TIPO_MONEDA).then((response) => {
        this.tiposDeMonedas = response.data
      }).catch(error => {
        if (error.response && error.response.data && error.response.status === NOT_FOUND) {
          this.tiposDeMonedas = []
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    },
    async limpiarFiltros () {
      this.date = null
      this.modelo = {
        tipoDocumentoId: null,
        numeroDocumento: null,
        fechaNacimiento: null,
        referencia: null
      }
      await this.$nextTick()
      this.tipoPago ? this.$refs.formularioReferencia.llenarFormulario(null) : this.$refs.formularioIdentificacion.llenarFormulario(null, this.modelo.tipoDocumentoId && this.modelo.tipoDocumentoId.codigo === 'NIT')
      this.$_generalParametersMixin_update(this.configColor.primary, this.configColor.secondary, this.generalParametersUrlLogo)
    },
    /**
   * Metodo para validar los parametros url y setearlo en el modelo
   *
   * @author Andres Correa
   * @version 1.0.0
   * @since 25/08/2020 02:24 PM
   */
    async validarQueryParams () {
      let response = this.$_validateQueryParamsMixin_indivual(this.validaQueryParam.data, this.validaQueryParam.query, this.validaQueryParam.valida)
      if (response) {
        this.filtrarPorReferencia()
      }
    }
  }
}
</script>

<style>

</style>

<i18n>
{
  "es": {
    "title": "Solicita tu cita o producto telefónicamente, para obtener el número de referencia de pago y el valor del servicio",
    "texto_informativo": "La información que se presenta a continuación pertenece al beneficiario del servicio, si desea actualizar algún dato por favor realizarlo directamente en la obra.",
    "form": {
      "label": {
        "referencia": "Número de referencia",
        "numero_referencia": "Número de referencia",
        "numero_identificacion": "Número de identificación",
        "numero_documento": "Número de documento",
        "tipo_documento": "Tipo de documento",
        "fecha_nacimiento": "Fecha de nacimiento"
      },
      "button": {
        "aceptar": "ACEPTAR"
      }
    },
    "referencia_404": "Referencia no encontrada",
    "identificacion_404": "Identificación no encontrada"
  }
}
</i18n>
